export default "__VITE_ASSET__CCYDpfrU__"